import { computed, Ref, WritableComputedRef } from 'vue';
import {
    postOrganisationalResultsTable,
    updateOrganisationalTableLayout,
} from './organisationalResultsApi';
import { EchoFilterRequest } from '../filter/types';
import { useMutation, useQuery } from '@tanstack/vue-query';
import { QK } from '@/js/consts/query-keys';
import {
    OrganisationalTableData,
    RequestUpdateOrganisationalTableLayout,
    ResponseGetOrganisationalTable,
} from './organisationalResultsModel';

export const useGetOrganisationalResultsTable = (
    page: WritableComputedRef<number>,
    pageSize: WritableComputedRef<number>,
    sortFieldId: WritableComputedRef<string | null>,
    sortOrder: WritableComputedRef<string | null>,
    filter: Ref<EchoFilterRequest>,
    parentGroupId: Ref<string | null>
) => {
    const queryKey = computed(() => [
        QK.ORGANISATIONAL_RESULTS.TABLE,
        page.value,
        pageSize.value,
        sortOrder.value ?? '',
        sortFieldId.value ?? '',
        filter.value,
        parentGroupId.value ?? '',
    ]);

    return useQuery<ResponseGetOrganisationalTable, Error, OrganisationalTableData>({
        queryKey,
        queryFn: async () =>
            await postOrganisationalResultsTable({
                page: page.value,
                pageSize: pageSize.value,
                sortOption:
                    sortFieldId.value && sortOrder.value
                        ? {
                              columnId: sortFieldId.value,
                              sortDirection:
                                  sortOrder.value.toLowerCase() === 'asc' ? 'Asc' : 'Desc',
                          }
                        : undefined,
                filter: filter.value,
                parentGroupId: parentGroupId.value ?? null,
            }),
        select: (data) => {
            const rows: any[] = [...data.rowHeaders];

            data.rowCells.forEach((cell) => {
                rows[cell.rowIndex][cell.columnId] = cell.value;
            });

            const totalRow = rows.find((r) => r && r.name === 'Total');
            return { ...data, rows, totalRow };
        },
    });
};

export const useMutationUpdateOrganisationalTableLayout = () => {
    return useMutation({
        mutationFn: async (columns: RequestUpdateOrganisationalTableLayout['columns']) =>
            await updateOrganisationalTableLayout({ columns, tableKey: 'OrganisationalResults' }),
    });
};
